import { lazy } from 'react';

export const ChallengePlayerAssignForm = lazy(
  () => import('./ChallengePlayerAssignForm'),
);
